import { Style, Fill, Stroke, Text } from "ol/style";
import { BaseStyle } from "../../../../lib/layers/selectable/styling/styles";
import { None } from "../../../../lib/misc/option";
export class ColorizedParcelStyle extends BaseStyle {
    constructor() {
        super();
        this.name = 'colorized';
        this.alt = true;
    }
    style_function(identifier, clicked, hovered, ignored = None.instance()) {
        return (feature) => {
            const bucket = feature.get('bucket');
            if (ignored.isSomeAnd(i => i().includes(bucket)))
                return new Style();
            const opacity = feature.get('opacity') || 0;
            const color = feature.get('color');
            if (!color) {
                return this.fallback_style();
            }
            let rgb_re = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
            if (!rgb_re)
                return this.fallback_style();
            let rgb = rgb_re.slice(1, 4).map(v => parseInt(v, 16));
            if (Array.isArray(clicked())) {
                if (clicked().includes(feature.get(identifier))) {
                    return this.clicked_style(rgb, opacity);
                }
            }
            if (feature.get(identifier) === clicked()) {
                return this.clicked_style(rgb, opacity);
            }
            if (feature.get(identifier) === hovered()) {
                return this.hovered_style(rgb, opacity);
            }
            return this.searched_style(rgb, opacity);
        };
    }
    fallback_style() {
        return new Style({
            fill: new Fill({
                color: 'rgba(209,204,220,1)'
            }),
            stroke: new Stroke({
                color: 'rgba(42,71,71,1)',
                width: 2
            }),
            text: new Text({
                text: "Added"
            })
        });
    }
    clicked_style(rgb, opacity) {
        return new Style({
            fill: new Fill({
                color: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity / 100})`
            }),
            stroke: new Stroke({
                color: this.alt ? `rgba(238, 232, 44,1)` : `rgba(${255 - rgb[0]}, ${255 - rgb[1]}, ${255 - rgb[2]}, 1)`,
                width: 4
            }),
            zIndex: 999999
        });
    }
    ;
    hovered_style(rgb, opacity) {
        return new Style({
            fill: new Fill({
                color: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity / 100})`
            }),
            stroke: new Stroke({
                color: this.alt ? `rgba(60, 145, 230,1)` : `rgba(${255 - rgb[1]}, ${255 - rgb[2]}, ${255 - rgb[0]}, 1)`,
                width: 4
            }),
            zIndex: 999
        });
    }
    ;
    searched_style(rgb, opacity) {
        return new Style({
            fill: new Fill({
                color: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity / 100})`
            }),
            stroke: new Stroke({
                color: this.alt ? `rgba(42,71,71,1)` : `rgba(${255 - rgb[2]}, ${255 - rgb[0]}, ${255 - rgb[1]}, 1)`,
                width: 2
            })
        });
    }
}
